<template>
  <div @click="handler" tag="div" class="item flex overflow-hidden">
    <div ref="ava" class="ava flex0 mr10">
      <img class="radius50" :src="info|DocAva" alt="" @error="__docError">
      <div v-if="info.docCcpRole" class="tac pt5">
        <span :class="['ccp-tag','ccp-tag'+info.docCcpRole]"></span>
      </div>
    </div>
    <div class="info flex1" :style="infoStyle">
      <h3 class="flex">
        <div class="flex1">
          <span class="color_333 fs16">{{ info.docName }}</span>
          <span class="kkcf_tag ml5" v-if="info.prescriptionStatus">可开处方</span>
        </div>
        <div class="flex0" v-if="info.docScoure">
          <font class="iconfont fs14 orange">&#xe664;</font>
          <span class="fs14 orange">{{ info.docScoure ? info.docScoure + '分' : '' }}</span>
        </div>
        <!--<font v-if="info.docScoure"
                                                                       class="iconfont fs12 orange">
        &#xe664;</font> <span
        class="fs12 orange">{{ info.docScoure ? info.docScoure + '分' : '' }}</span>-->
      </h3>
      <div class="color_666 mt5 fs14">{{ info.docDeptName }}<span v-html="renderDocTitleHtml(info)"></span></div>
      <div class="color_666 mt5">{{ info.docHosName }}</div>
      <ul class="mt5 tags flex" v-if="info.docTags && info.docTags.length">
        <li v-for="(item,index) in info.docTags" :key="index" class="fs12 flex0 mr5 mb5 ellipsis">{{ item }}</li>
      </ul>
      <div class="mt5 color_999 skill">擅长：{{ info.docSkill }}</div>
      <doc-services :info="info" class="mt10"></doc-services>
      <p class="mt10 flex" v-if="info.consultAvgReplyTimeDescription">
        <span class="pjxysj_tag">平均响应时间：{{ info.consultAvgReplyTimeDescription }}</span>
        <!--        <span
                  class="fs13 color_main border radius5 pt2 pb3 pl5 pr5" v-if="info.prescriptionStatus">可开处方</span>-->
      </p>
    </div>
  </div>
</template>

<script>
import DocAva from '../../utils/docAva'
import {avaErrorMixin} from "@/lib/mixin";
import DocServices from "../../page/group/components/doc-services-v2.vue";
import {docTitleMixin} from "@/page/doc/lib";

export default {
  name: 'common-doc-list-item-v2',
  props: {
    info: Object,
    toDocCard: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      team: null,
      infoStyle: {}
    };
  },
  computed: {},
  filters: {DocAva},
  components: {DocServices},
  mixins: [avaErrorMixin, docTitleMixin],
  created() {
    this.getDetail()
  },
  mounted() {
    this.$nextTick(() => {
      const w = Math.min(window.innerWidth, screen.availWidth);
      console.log('w', w);
      let avaEl = this.$refs.ava;
      let avaStyle = getComputedStyle(avaEl);
      console.log('style', avaStyle.marginRight, avaStyle.width);
      this.infoStyle = {
        maxWidth: `calc(${w}px - 1.6rem - ${avaStyle.width} - ${avaStyle.marginRight})`
      }
    })
  },
  beforeDestroy() {

  },
  methods: {
    handler() {
      if (this.toDocCard)
        this.$router.push({path: '/onlineDoctorCard', query: {docId: this.info.docId, ...this.$route.query}})
      else {
        this.$emit('click', this.info);
      }
    },
    async getDetail() {

    }
  }
};
</script>

<style scoped lang="scss">
@import "../../common/public";
@import "~@/page/doc/doc.scss";

.border {
  border-color: $mainColor;
}

.orange {
  color: #F68D4F;
}

.item {
  padding: px2rem(15px) 0 px2rem(15px) px2rem(15px);
  margin-right: px2rem(15px);
}

.item + .item {
  @include border(top);
}

.ava {
  @include w_h(px2rem(60px), px2rem(60px));

  img {
    @include w_h(px2rem(60px), px2rem(60px));
  }
}

.info {
  line-height: 1.2;
  max-width: calc(100vw - 5.33em);
}

.skill {
  @include lines(2);
}

.state {
  img {
    height: px2rem(15px);
  }

  li {
    align-items: center;
    display: flex;

    div {
      word-break: break-word;
    }
  }
}

.kkcf_tag {
  background: rgba(8, 147, 255, 0.08);
  color: #0893FF;
  font-size: px2rem(12px);
  border-radius: px2rem(2px);
  padding: px2rem(2px) px2rem(5px);
}

.pjxysj_tag {
  background: #FDF7EE;
  border-radius: px2rem(13px);
  font-size: px2rem(11px);
  color: #BE7305;
  padding: px2rem(3px) px2rem(8px) px2rem(2px);
  font-weight: 400;
}

.tags {
  li {
    max-width: 100%;
    background: rgba(8, 147, 255, 0.08);
    color: #0893FF;
    line-height: px2rem(18px);
    padding-left: px2rem(5px);
    padding-right: px2rem(5px);
    border-radius: px2rem(2px);
  }
}
</style>



// WEBPACK FOOTER //
// src/plugins/consult/doc-item-v2.vue